import { useImmer } from 'use-immer'
import { Button, message } from 'antd'
import { isEmpty, set, cloneDeep, pick, unset } from 'lodash'
import { t } from 'helpers/i18n'
import linkTargets from 'options/linkTargets'
import { showError, showClientNotifications } from 'helpers/errors'
import Icon from 'elements/Icon'
import Drawer from 'elements/Drawer'
import FormView from 'containers/Rfqs/FormView'

function Component(props) {
  const { parentRecord, parentHasUnsavedChanges, selectedRowKeys } = props

  const [state, updateState] = useImmer({})

  function setState(path, value) {
    updateState((draft) => {
      set(draft, path, value)
    })
  }

  async function handleCopyClick() {
    if (parentHasUnsavedChanges) {
      message.error(t('saveChangesFirst'))
      return
    }

    try {
      setState('loading', true)

      const copied = await props.newItem({}).then((r) => cloneDeep(r.value.data))

      unset(copied, 'id')

      Object.assign(
        copied,
        pick(parentRecord, [
          'buyerName',
          'buyerPhone',
          'buyerEmail',
          'requisitionerName',
          'requisitionerPhone',
          'requisitionerEmail',
          'shipToAddressId',
          'deliveryDueDate',
          'customerComment',
          'internalComment',
          'responseDueDate',
        ])
      )

      const rfqItems = parentRecord.rfqItems
        .filter((each) => selectedRowKeys.includes(each.id))
        .map((each) => ({
          timeScanned: new Date().toJSON(),
          serverTimeScanned: new Date().toJSON(),
          userName: props.user.userName,
          productId: each.productId,
          barcode: each.barcode,
          inventoryBarcode: each.inventoryBarcode,
          itemNumber: each.itemNumber,
          description: each.description,
          locationId: each.locationId,
          binLocation: each.binLocation,
          manufacturer: each.manufacturer,
          nonStock: props.customer.generalSettings.addNonStockToProducts ? false : each.nonStock,
          price: each.price,
          unitOfMeasure: each.unitOfMeasure,
          packageSize: each.packageSize,
          packageSizeUom: each.packageSizeUom,
          quantity: each.quantity,
          taxable: each.taxable,
          taxableDescription: each.taxableDescription,
          expedite: each.expedite,
          deliveryDate: each.deliveryDate,
          locationBarcode: each.locationBarcode,
          locationName: each.locationName,
          sourceCatalogName: each.sourceCatalogName,
          jobId: each.jobId,
          jobName: each.jobName,
          operatorId: each.operatorId,
          operatorName: each.operatorName,
          assetBarcode: each.assetBarcode,
          tagA: each.tagA,
          tagB: each.tagB,
          tagC: each.tagC,
          tagD: each.tagD,
          tagE: each.tagE,
          supplierDetails: each.supplierDetails,
        }))

      const rfqSuppliers = parentRecord.rfqSupplierItems.map((each) => ({
        supplierId: each.supplierId,
        supplierPosition: each.supplierPosition,
        comment: each.comment,
        freightCost: each.freightCost,
        promiseDate: each.promiseDate,
      }))

      const response = await props.saveRfq({
        rfq: copied,
        rfqItems: { creating: rfqItems },
        rfqSuppliers: { creating: rfqSuppliers },
      })

      showClientNotifications({ response })

      if (response.value.data.failureCount > 0) {
        throw new Error()
      }

      updateState((draft) => {
        draft.linkTargetRecord = response.value.data.items[0]
        draft.drawerVisible = true
      })
    } catch (error) {
      showError({ error })
    } finally {
      setState('loading', false)
    }
  }

  return (
    <>
      <Button onClick={handleCopyClick} disabled={isEmpty(selectedRowKeys)} loading={state.loading}>
        {!state.loading && <Icon type="ContentCopy" />} {t('copy')}
      </Button>
      <Drawer
        title={t('copy')}
        size={linkTargets.rfqRecord.formSize}
        visible={state.drawerVisible}
        onClose={() => setState('drawerVisible', false)}
      >
        <FormView
          linkTargetRecord={state.linkTargetRecord}
          onSave={() => {}}
          onSaveAndClose={() => setState('drawerVisible', false)}
          onCancel={() => setState('drawerVisible', false)}
        />
      </Drawer>
    </>
  )
}

export default Component
